import BaseComponent from "@js/components/base_component.jsx";

import MuiSubAccountsForm from "@js/components/mui/sub_accounts/form.jsx";

class MuiSubAccountsShow extends BaseComponent {

  render() {
    return (
      <MuiSubAccountsForm { ...this.props } editing={ false } />
    );
  }

}

export default MuiSubAccountsShow;
